/**
 * Vollständiges JavaScript mit Fade-In Funktionalität
 * Dieser Code initialisiert alle Parallax-Banner-Instanzen
 * auf der Seite und sorgt für zentrierte Ausrichtung, fade-in
 * und Arrow-/Dot-Logik.
 */
document.addEventListener('DOMContentLoaded', function () {
  // Für jede .parallax-section mit data-section-id…
  document.querySelectorAll('.parallax-section[data-section-id]').forEach(sectionEl => {
    const sid = sectionEl.getAttribute('data-section-id');
    const container = document.getElementById(`scroll-container-${sid}`);
    if (!container) return;

    // Pfeil-Elemente pro Section
    const leftArrowDesktop  = document.getElementById(`arrow-left-desktop-${sid}`);
    const rightArrowDesktop = document.getElementById(`arrow-right-desktop-${sid}`);
    const leftArrowMobile   = document.getElementById(`arrow-left-mobile-${sid}`);
    const rightArrowMobile  = document.getElementById(`arrow-right-mobile-${sid}`);

    // Funktion: prüft, ob der Inhalt breiter als der Container ist
    function updateAlignment() {
      if (container.scrollWidth > container.clientWidth) {
        container.classList.add('overflow-active');
        container.classList.remove('fit-content');
      } else {
        container.classList.add('fit-content');
        container.classList.remove('overflow-active');
      }
    }

    // Initiale Prüfung beim Laden
    updateAlignment();
    // Bei Resize erneut prüfen
    window.addEventListener('resize', updateAlignment);

    // Scroll-Funktion
    function scrollBannerContainer(dir) {
      const scrollAmount = container.clientWidth * 0.8;
      container.scrollBy({ left: dir * scrollAmount, behavior: 'smooth' });
    }

    if (leftArrowDesktop)  leftArrowDesktop.addEventListener('click', () => scrollBannerContainer(-1));
    if (rightArrowDesktop) rightArrowDesktop.addEventListener('click', () => scrollBannerContainer(1));
    if (leftArrowMobile)   leftArrowMobile.addEventListener('click',   () => scrollBannerContainer(-1));
    if (rightArrowMobile)  rightArrowMobile.addEventListener('click',   () => scrollBannerContainer(1));

    // Pfeile nur anzeigen, wenn Overflow vorhanden
    function checkArrows() {
      if (container.scrollWidth > container.clientWidth) {
        container.classList.add('overflow-active');
        if (leftArrowDesktop)  leftArrowDesktop.parentElement.style.display = 'flex';
        if (rightArrowDesktop) rightArrowDesktop.parentElement.style.display = 'flex';
        if (leftArrowMobile)   leftArrowMobile.parentElement.style.display = 'flex';
        if (rightArrowMobile)  rightArrowMobile.parentElement.style.display = 'flex';
      } else {
        container.classList.remove('overflow-active');
        if (leftArrowDesktop)  leftArrowDesktop.parentElement.style.display = 'none';
        if (rightArrowDesktop) rightArrowDesktop.parentElement.style.display = 'none';
        if (leftArrowMobile)   leftArrowMobile.parentElement.style.display = 'none';
        if (rightArrowMobile)  rightArrowMobile.parentElement.style.display = 'none';
      }
    }

    window.addEventListener('resize', checkArrows);
    checkArrows();

    // Fade-In: Intersection Observer
    const fadeItems = container.querySelectorAll('.fade-in');
    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('fade-in-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    fadeItems.forEach(el => observer.observe(el));

    // Mobile-Dots: Scroll-Sync
    const dotsContainer = document.getElementById(`mobile-dots-${sid}`);
    const dots = dotsContainer ? dotsContainer.querySelectorAll('.dot') : [];
    if (dots.length) {
      container.addEventListener('scroll', () => {
        const children = Array.from(container.children);
        const center = container.scrollLeft + container.clientWidth / 2;
        let closestIndex = 0;
        let closestDistance = Infinity;
        children.forEach((child, index) => {
          const childCenter = child.offsetLeft + child.offsetWidth / 2;
          const distance = Math.abs(childCenter - center);
          if (distance < closestDistance) {
            closestIndex = index;
            closestDistance = distance;
          }
        });
        dots.forEach(dot => dot.classList.remove('active'));
        if (dots[closestIndex]) {
          dots[closestIndex].classList.add('active');
        }
      });
    }
  });
});
